<template>
  <!--  友好提示 弹框 ，不需要 操作-->
  <div>
    <eDialog
      dialogType="other"
      dialogTitle="易派客提醒您："
      buttonTip="我知道了"
      :isShowCancel="isShowCancel"
      popupWidth="500px"
      :centerDialogVisible="friendlyReminderVisible"
      @resetPopupData="resetPopupData"
      @submitPopupData="resetPopupData"
    >
      <div v-html="friendlyReminderContent"></div>
    </eDialog>

  </div>
</template>

<script>
  import eDialog from "../../../components/common/e-dialog.vue";
  export default {
    name: "friendlyReminderDialog",
    components:{eDialog},
    props:{
      friendlyReminderVisible:Boolean,
      friendlyReminderContent:String
    },
    data() {
      return {
        isShowCancel:false,
      }
    },
    methods:{
      resetPopupData(){
        this.$emit('closeDialog');
      },
    },
  }
</script>

<style scoped>

</style>
